import React, {useState} from 'react';
import '../styles/Navbar.css'
import logo from './logo.png'
import burgerIcon from './burger-menu.svg';
// import './burger-menu.js';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className='header'>
      <a href="/">
        <img src={logo} className='navbar-logo fade-in' alt='Nature Cam'/>
      </a>
      {/* <input type="checkbox" id="menyAvPaa"></input>
      <label id="burger" for="menyAvPaa">
        <div></div>
        <div></div>
        <div></div>
      </label>
      <nav id="meny">
      </nav> */}

          {/* <div>
            <img
              src={logo}
              className='navbar-logo'
              alt='Oldplay'
              onClick={() => navigate('/')}
            />
          </div> */}

          <img
              src={burgerIcon}
              alt="Menu"
              onClick={() => setIsOpen(!isOpen)}
              className="burger-icon"
          />
          {isOpen && (
            <>
                <div className="overlay" onClick={() => setIsOpen(false)}></div>
                <div className={`menu ${isOpen ? 'menu-open' : ''}`}>
                  <a href="/">Home</a>
                  {/* <a href="/catalog">Catalog</a> */}
                  <a href="/about">About</a>
                  <a href="/contact">Contact</a>
              </div>
            </>
          )}

      {/* <Menu 
        isOpen={isOpen}
        onStateChange={({ isOpen }) => setIsOpen(isOpen)}
        customBurgerIcon={<div className='burger-icon'><div/><div/><div/></div>}
      >
        <a href="/">Home</a>
        <a href="/about">About</a>
        <a href="/contact">Contact</a>
      </Menu> */}
    </nav>
  );
}
export default Navbar;